import { colors, medias, mixins, shadows, sizes, typography } from "features/theme/variables"

export const sensidiagFoTheme = {
  colors,
  medias,
  mixins,
  shadows,
  sizes,
  typography,
}

export type SensidiagFoTheme = typeof sensidiagFoTheme
